<template>
  <div id="app">
    <Navbar id="navbar" :class="{ 'dimmed': showLoginModal }" @show-login="showLoginModal = true"/>
    <!-- Global API error toast -->
    <transition name="fade">
      <div v-if="showAPIErrorInfo" class="api-error-banner" @click="dismissError">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>{{ apiErrorInfo.msg || 'Something went wrong. Please try again later.' }}</span>
        <button class="api-error-close" aria-label="Dismiss">&times;</button>
      </div>
    </transition>
    <router-view id="router-v" @show-login="showLoginModal = true" />
    <b-modal v-model="showLoginModal" hide-footer hide-header centered modal-class="custom-modal-backdrop">
      <button type="button" class="close-button" @click="showLoginModal = false" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <div class="login-page-container">
        <component-login @close-modal="showLoginModal = false"></component-login>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import constants from "@/constants";
import Login from "./components/UserAccounts/Auth/Login.vue";

export default {
  data() {
    return {
      showAPIErrorInfo: false,
      showLoginModal: false
    }
  },
  computed: {
    apiErrorInfo() {
      return this.$store.state.apiErrorInfo;
    },
    constants() {
      return constants;
    }
  },
  watch: {
    '$store.state.apiErrorInfo': function (newVal) {
      if (newVal.status) {
        this.showAPIErrorInfo = true;
        // Auto-dismiss after 6 seconds
        clearTimeout(this._errorTimer);
        this._errorTimer = setTimeout(() => { this.dismissError(); }, 6000);
      }
    }
  },
  methods: {
    dismissError() {
      this.showAPIErrorInfo = false;
      this.$store.commit('resetAPIErrorInfo');
    }
  },
  components: {
    Navbar,
    "component-login": Login
  },
  mounted() {
    this.$store.commit('resetAPIErrorInfo');
    if (this.$store.getters.loggedIn) {
      this.$store.dispatch('getUserInfo')
    }
  },
};
</script>

<style>
#app {
  font-family: "Roboto Condensed";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: white;
  display: grid;
  grid-template-rows: 8.5vh auto;
  height: 100vh;
  padding: 0 !important;
  margin: 0 !important;
}

#navbar {
  grid-row: 1 / 2;
}

#router-v {
  padding-top: 110px;
  box-sizing: border-box;
  height: 100vh;
}

.login-page-container {
  background-color: #f7f7f7;
  overflow: hidden;
}

/* Override Bootstrap modal backdrop */
.modal-content {
  background-color: #f7f7f7 !important;
}

.modal-backdrop {
  opacity: 0.5 !important;
  background-color: #000 !important;
}

.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  z-index: 1;
}

.close-button:hover {
  opacity: 0.75;
}

#navbar.dimmed {
  position: relative;
  pointer-events: none;
}

#navbar.dimmed::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  pointer-events: none;
}

/* Global API error banner */
.api-error-banner {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  background-color: #d9534f;
  color: #fff;
  padding: 12px 40px 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  max-width: 90vw;
}
.api-error-close {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #fff;
  font-size: 1.3rem;
  cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
